export default {
  label: {
    exportLabel: 'Baixar em',
    exportLabelType: 'Baixar em {type}',
  },
};
